import React, { Component } from 'react'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'

import LoadModuleContent from '../Utils/LoadModuleContent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder } from '@fortawesome/pro-duotone-svg-icons/faFolder'

import DefaultGrid from '@/feature/Grid/DefaultGrid'
import AvatarGroup from '@/feature/user/avatar/AvatarGroup'
import { StyledVerticalTab } from '@/shared/ui/tabs'
import { brandedTabsSx, brandedTabsWrapSx } from '@/shared/ui/styles'

/**
 * Material UI conversion of DefaultPageTemplate
 * - react-bootstrap Row/Col/Nav/Tab/Alert -> MUI Grid/Tabs/Tab/Alert
 * - Keeps the existing props API and layout logic intact
 */
class DefaultPageTemplate extends Component<any, any> {
    constructor(props: any) {
        super(props)

        this.state = {
            displayPositions: this.props.displayPositions,
            content: this.props.content,
            edit: false,
            id: this.props.id,
            layout_sidebar:
                this.props.defdossier &&
                this.props.defdossier.settings &&
                this.props.defdossier.settings.layout_sidebar
                    ? this.props.defdossier.settings.layout_sidebar
                    : null,
        }
    }

    private renderAlertArchive() {
        return (
            <Alert
                severity="info"
                sx={{ display: 'flex', alignItems: 'center' }}
            >
                <span style={{ marginRight: 8 }}>
                    <FontAwesomeIcon icon={faFolder} />
                </span>
                {this.props.kedo.t('This item is archived')}
            </Alert>
        )
    }

    private renderFooter(displayPosition: any) {
        if (
            !displayPosition ||
            !displayPosition.display_items ||
            displayPosition.display_items.length <= 0
        ) {
            return ''
        }

        return (
            <Box>
                <Box component="hr" className="contentDossier" />
                <Grid container>
                    <Grid size={12}>
                        {this.props.getDisplayPositionContent(
                            displayPosition,
                            false,
                            true
                        )}
                    </Grid>
                </Grid>
            </Box>
        )
    }

    private getContentByView(
        displayContents: any[],
        displayItems: any[],
        viewName: string
    ) {
        const returnContent: Record<string | number, any> = {}

        const filterItems = displayItems.filter(
            (displayItem) => displayItem.view === viewName
        )

        if (filterItems.length >= 0) {
            filterItems.forEach((displayItem) => {
                const find = displayContents.find(
                    (content) => content.content.id == displayItem.id
                )
                if (find) {
                    returnContent[displayItem.id] = find.content.content
                }
            })
        }

        return returnContent
    }

    private renderSidebar(displayPositions: any[], activeTab: any) {
        if (displayPositions && displayPositions.length <= 0) return null

        const view = isNaN(this.state.layout_sidebar)
            ? this.state.layout_sidebar
            : 'show/edit'

        return (
            <Grid container>
                <Grid
                    size={12}
                    sx={{
                        borderLeft:
                            this.props.modalized && window.innerWidth > 576
                                ? '1px solid #dee2e6'
                                : undefined,
                    }}
                >
                    <DefaultGrid
                        key={this.props.dossier.id}
                        defDossierSettings={
                            this.props.defdossier &&
                            this.props.defdossier.settings
                                ? this.props.defdossier.settings
                                : null
                        }
                        conditions={
                            this.props.defdossier &&
                            this.props.defdossier.settings &&
                            this.props.defdossier.settings.conditions
                                ? this.props.defdossier.settings.conditions
                                : []
                        }
                        content={this.getContentByView(
                            this.props.sidebarContent.filter(
                                (contentItem: any) =>
                                    contentItem.id === this.props.dossier.id
                            ),
                            this.props.sidebarDisplayItems,
                            view
                        )}
                        dossier={this.props.dossier}
                        items={this.props.sidebarDisplayItems.filter(
                            (displayItem: any) => displayItem.view === view
                        )}
                        kedo={this.props.kedo}
                        mode={
                            isNaN(this.state.layout_sidebar)
                                ? this.state.layout_sidebar
                                : 'show'
                        }
                        withoutEdit={true}
                    />
                </Grid>
            </Grid>
        )
    }

    private renderMetadata(metadataPosition: any) {
        if (
            !metadataPosition ||
            !metadataPosition.display_items ||
            metadataPosition.display_items.length <= 0
        ) {
            return ''
        }

        return (
            <Box className="contentDossierMetadata">
                <Grid container>
                    <Grid size={12}>
                        {this.props.getDisplayPositionContent(
                            metadataPosition,
                            false,
                            true
                        )}
                    </Grid>
                </Grid>
                <Box component="hr" className="contentDossier" />
            </Box>
        )
    }

    private getDefaultTabId(displayPositions: any[], activeTab: any) {
        const mainPosition = displayPositions.find(
            (item: any) => item.type === 'main_content'
        )
        return activeTab && parseInt(activeTab) > 0
            ? parseInt(activeTab)
            : mainPosition?.id
    }

    private renderTabs(displayPositions: any[], activeTab: any) {
        const kedo = this.props.kedo

        if (displayPositions && displayPositions.length <= 0) {
            throw new Error(this.props.kedo.t('404_general_message'))
        }

        const metadataPosition = displayPositions.find(
            (item: any) => item.type === 'meta'
        )

        const positionsFiltered = displayPositions.filter(
            (position: any) =>
                position.type === 'tab' || position.type === 'main_content'
        )

        const visiblePositions = positionsFiltered.filter(
            (item: any) => !item.hide && item.hide !== true
        )

        const defaultTabId = this.getDefaultTabId(displayPositions, activeTab)

        const selectedTab =
            activeTab && parseInt(activeTab) > 0
                ? parseInt(activeTab)
                : defaultTabId

        const handleChange = (_: any, newValue: any) => {
            // match react-bootstrap Tab.Container onSelect behavior
            this.props.handleTabSelect?.(newValue)
        }

        const currentTab = visiblePositions.find(
            (p: any) => p.id === selectedTab
        )

        return (
            <Box>
                <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    aria-label="content dossier tabs"
                    className="contentDossierNav"
                    sx={[brandedTabsSx, brandedTabsWrapSx]}
                >
                    {visiblePositions.map((item: any) => (
                        <StyledVerticalTab
                            key={item.id}
                            value={item.id}
                            label={kedo
                                .env()
                                .translateItem(item, 'displayposition', true)}
                            className={
                                item.type === 'main_content' ? 'mainLink' : ''
                            }
                        />
                    ))}
                </Tabs>

                <Box sx={{ mt: 2 }}>
                    {currentTab ? (
                        <Box
                            className={
                                currentTab.type === 'main_content'
                                    ? 'primaryTab contentDossierTab'
                                    : 'subTab'
                            }
                        >
                            <Box className="tabCD" id={currentTab.id}>
                                {this.renderMetadata(metadataPosition)}

                                <Box className="tabCD-content">
                                    <Typography
                                        component="h3"
                                        sx={{
                                            fontSize: '1.7em',
                                            fontWeight: 700,
                                            lineHeight: 1.2,
                                            mb: 2,
                                        }}
                                    >
                                        {currentTab.translations?.find(
                                            (lang: any) =>
                                                lang.culture ===
                                                kedo.getCulture()
                                        )
                                            ? currentTab.translations.find(
                                                  (lang: any) =>
                                                      lang.culture ===
                                                      kedo.getCulture()
                                              ).name_plural
                                            : currentTab.name_plural}
                                    </Typography>

                                    {(!activeTab &&
                                        currentTab.type === 'main_content') ||
                                    parseInt(activeTab) === currentTab.id
                                        ? this.props.getDisplayPositionContent(
                                              currentTab,
                                              this.props.isAllowedEditTab(
                                                  currentTab
                                              )
                                          )
                                        : kedo.t('No tab selected')}

                                    {(!activeTab &&
                                        currentTab.type === 'main_content') ||
                                    (parseInt(activeTab) === currentTab.id &&
                                        this.props.loadModule) ? (
                                        <LoadModuleContent
                                            dossierId={this.props.id}
                                            module={this.props.loadModule}
                                            kedo={kedo}
                                        />
                                    ) : null}
                                </Box>
                            </Box>
                        </Box>
                    ) : (
                        <Typography>{kedo.t('No tab selected')}</Typography>
                    )}
                </Box>
            </Box>
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid size={{ md: this.state.layout_sidebar ? 9 : 12 }}>
                    {this.props.showExisting.length > 0
                        ? this.props.renderExisting()
                        : null}

                    <Box className="content-section">
                        <Box className="mainContainer">
                            {!this.props.modalized &&
                            this.props.embeddedInlineSingle !== true
                                ? this.props.getGeneralHeader()
                                : null}

                            <Box>
                                <AvatarGroup
                                    users={this.props.socketUsers}
                                    kedo={this.props.kedo}
                                />
                            </Box>

                            {this.props.dossier && this.props.dossier.archived
                                ? this.renderAlertArchive()
                                : null}

                            {this.props.showSaveSuccess
                                ? this.renderSuccessAlert?.()
                                : null}

                            {!this.props.modalized ? (
                                <Box sx={{ py: 1 }} />
                            ) : null}

                            {this.renderTabs(
                                this.props.displayPositions,
                                this.props.activeTabKey
                            )}

                            {this.renderFooter(
                                this.props.displayPositions.find(
                                    (item: any) => item.type === 'footer'
                                )
                            )}
                        </Box>
                    </Box>
                </Grid>

                {this.state.layout_sidebar ? (
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Box className="content-section">
                            <Box className="mainContainer">
                                {this.renderSidebar(
                                    this.props.displayPositions,
                                    this.props.activeTabKey
                                )}
                            </Box>
                        </Box>
                    </Grid>
                ) : null}
            </Grid>
        )
    }
}

export default DefaultPageTemplate
